import { Component, Input } from '@angular/core';

@Component({
  selector: 'tangram-role-badge',
  templateUrl: './role-badge.component.html',
  styleUrls: ['./role-badge.component.scss']
})
export class RoleBadgeComponent {
  @Input() role: string = 'STUDENT';

  get displayRole(): string {
    const normalized = (this.role || '').toUpperCase();
    if (normalized === 'SUPER_USER') {
      return 'Professor';
    }
    if (normalized === 'CURATOR') {
      return 'Professor';
    }
    if (normalized === 'TA') {
      return 'TA';
    }
    return 'Student';
  }
}
